import React from 'react';
import styles from '../maruciapiercer/trabalhos_maruciapiercer.module.scss';

const Trabalhos_maruciapiercer: React.FC = () => {
    return (
        <div className={styles.trabalhos_maruciapiercer}>

        </div>
    );
};

export default Trabalhos_maruciapiercer;
